<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Promotional Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput label="Title" placeholder="Enter Notification title" v-model="promotion.title" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
            label="Body"
            placeholder="Enter Body"
            v-model="promotion.body"
          />
        </CCol>
      </CRow>
      <CRow v-if="promotion.image">
        <CCol sm="12">
          <img :src="img_url" style="width: 240px; height: 180px;" />
          <CInputFile
            label="Image thumbnail"
            vertical
            ref="file"
            type="file"
            id="file"
            @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger">(Image Size should be (480 X 360) and less than 1 MB)</label>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInputCheckbox label="Published status" :checked.sync="promotion.published_status" />
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Update Promotion
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "PromotionEdit",
  data() {
    return {
      promotion: {},
      img_url: "",
      categories: [],
      selectedCategory: 1,
    };
  },
  created() {
    this.getPromotion();
  },
  methods: {
    getPromotion() {
      this.$axios
        .get(`${ADMIN_URL}/promotions/${this.$route.params.id}`)
        .then((response) => {
          console.log(response.data);
          this.promotion = response.data.data;
          this.img_url = this.promotion.image;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.promotion.image = file;
      this.img_url = URL.createObjectURL(file);
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("title", this.promotion.title);
      formData.append("body", this.promotion.body);  
      formData.append("image", this.promotion.image);
      formData.append("_method", "put");
       if(this.promotion.published_status)
        {
            formData.append("published_status", this.promotion.published_status);
        }

      this.$axios
        .post(`${ADMIN_URL}/promotions/${this.$route.params.id}`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          if(response.data.success)
          {
            this.$swal("Success", response.data.message, "success");
          }
          else
          {
            this.$swal("Error",  response.data.message, "error");
          }

        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
  },
};
</script>

<style scoped>
</style>
